const NUTPLAN_URL = process.env.API_URL + '/nutritional-plan';
const SAVE_URL = process.env.API_URL + '/nutritional-plan-custom';

const getPlans = (context,startDate, endDate, lang, userId) => {
  return new Promise((resolve, reject) => {
    context.$http.get(NUTPLAN_URL+ '/V2', {params: {startDate, endDate, lang, userId}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};


const savePlan = (context, plan, userId) => {
  return new Promise((resolve, reject) => {
    context.$http.post(SAVE_URL + '/save', plan, { params: { userId } })
      .then((response) => resolve(response.body), error => reject(error));
  });
};

const randomRecipe = (context, userId, date, mealType, lang) => {
  return new Promise((resolve, reject) => {
    context.$http.put(NUTPLAN_URL + '/' + userId+ '/' + date + '/' + mealType,{} ,{params:{lang}} )
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
}

const saveWeeksPlan = (context, plan, userId, weeks) => {
  return new Promise((resolve, reject) => {
    context.$http.post(SAVE_URL + '/assign', plan, { params: { userId, weeks } })
      .then((response) => resolve(response.body), error => reject(error));
  });
};

export default {
  getPlans,
  savePlan,
  randomRecipe,
  saveWeeksPlan
}



// WEBPACK FOOTER //
// ./src/brand/health/api/nutritionalPlan/index.js